const AddRatingAT = {
  ADD_RATING_REQUEST: 'ADD_RATING_REQUEST',
  ADD_RATING_SUCCESS: 'ADD_RATING_SUCCESS',
  ADD_RATING_FAILURE: 'ADD_RATING_FAILURE',
} as const;

export default { ...AddRatingAT };
